__turbopack_context__.v({
  "className": "Pgw7sW_className",
});
